import { render } from "./NewsSingle.vue?vue&type=template&id=0ff8cdf4"
import script from "./NewsSingle.vue?vue&type=script&lang=js"
export * from "./NewsSingle.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__